<script setup>
import menus from '@/components/menus'
import {useRouter} from "vue-router";
const router = useRouter()
</script>

<template>
  <div class="navs">
    <div>
      <img style="width: 40px;height: 40px;margin-right: 10px" src="@/assets/logo.png" alt="">
      兮颜毕设资源分享</div>
    <div>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          操作管理<el-icon><ArrowDown /></el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="router.push('/login')">退出管理</el-dropdown-item>
            <el-dropdown-item @click="router.push('/')">门户页面</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
<!--    <div  @click="router.push('/login')">退出</div>-->
  </div>
 <el-row>
   <el-col :span="4" class="leftnav">
     <menus></menus>
   </el-col>
   <el-col :span="20" class="app-container">
     <router-view></router-view>
   </el-col>
 </el-row>

</template>

<style scoped>
.navs{
  height: 80px;
  line-height: 80px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow:0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1) !important;
}
.navs >div:nth-child(1){
  font-size: 24px;
  font-weight: bold;
  display: flex;
  background-image: linear-gradient(120deg, #54b6d0 16%, #3f8bdb, #2c77f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  align-items: center;
}
.leftnav{
  height: 100vh;
  background: #545c64;
  color: #fff;
}
.app-container{
  padding: 20px;
  box-sizing: border-box;
}
.el-dropdown{
  height: 80px;
  line-height: 80px;
}

</style>
